module.exports = __webpack_public_path__ + "static/media/bottleshot_chardonnay.b0a02fa2.png";